import { LoginPage } from "./LoginPage";

export const StartPage = () => {
  return <LoginPage />;
};
